import React, { useState } from "react";
import { ReactSortable } from "react-sortablejs";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import FilterRenderer from "../../../components/BuilderComponents/FilterRenderer";
import InlineStyleSelector from "../../../components/BuilderComponents/InlineStyleSelector";
import PreFilter from "../../../components/BuilderComponents/PreFilters/PreFilter";
import TableTreeModal from "../../../components/BuilderComponents/TableTreeModal";
import Button from "../../../components/FormComponents/Button";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";
import BuilderRightSideBar from "../../../Layouts/BuilderRightSideBar";
import BuilderTabs from "../../../Layouts/BuilderTabs";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { toastError } from "../../../utils/toastUtils";

const KanbanStatesRenderer = ({ nonSelectedSmStates, setNonSelectedSmStates, allStates }) => {
  const { currentBlockConfig, setCurrentBlockConfig } = useAppBlocksContext();
  const [isEditBarOpen, setIsEditBarOpen] = useState(false);

  const addState = (index) => {
    const { name, id } = nonSelectedSmStates[index];
    const obj = { name, id };
    const newConfig = JSON.parse(JSON.stringify(currentBlockConfig));
    newConfig.data.states.push(obj);
    const newNonSelected = nonSelectedSmStates.filter((_, i) => i !== index);
    setNonSelectedSmStates(newNonSelected);
    setCurrentBlockConfig(newConfig);
  };

  const removeState = (index) => {
    const newConfig = JSON.parse(JSON.stringify(currentBlockConfig));
    const obj = newConfig.data.states[index];
    const newNonSelected = [...nonSelectedSmStates];
    newNonSelected.push(obj);
    setNonSelectedSmStates(newNonSelected);
    const newArray = newConfig.data.states.filter((_, i) => i !== index);
    newConfig.data.states = newArray;
    setCurrentBlockConfig(newConfig);
  };

  const changeOrderOfStates = (newList) => {
    const newConfig = JSON.parse(JSON.stringify(currentBlockConfig));
    newConfig.data.states = newList;
    setCurrentBlockConfig(newConfig);
  };

  return (
    <div className="p_4">
      <div className="main_page_top">
        <label className="section_main_heading mb_0">Select State from below</label>
        <Button onClick={() => setIsEditBarOpen(true)}>Edit Kanban</Button>
      </div>
      <div className="selected_chip_container ">
        {nonSelectedSmStates.map((state, index) => (
          <div className="selected_chip_items" key={state.id} onClick={() => addState(index)}>
            {state.name}
          </div>
        ))}
      </div>
      <div className="mt_3 mb_2">
        {currentBlockConfig?.data.states.length > 0 ? (
          <ReactSortable
            filter=".addImageButtonContainer"
            handle=".statekanbandrag"
            list={currentBlockConfig.data.states}
            setList={changeOrderOfStates}
            animation="200"
            easing="ease-out"
            className="selected_chip_container"
          >
            {currentBlockConfig.data.states.map((state, index) => (
              <div
                className="selected_chip_drag  selected_chip_items statekanbandrag
              "
                key={state.id}
              >
                <MaterialIcon name="drag_indicator" />
                <span> {state.name}</span>
                <MaterialIcon name="close" className="close_icon" onClick={() => removeState(index)} />
              </div>
            ))}
          </ReactSortable>
        ) : (
          <h3>Select states</h3>
        )}
      </div>
      {currentBlockConfig?.data.states.length > 0 && (
        <StateTransition
          currentBlockConfig={currentBlockConfig}
          setCurrentBlockConfig={setCurrentBlockConfig}
          allStates={allStates}
        />
      )}
      <BuilderRightSideBar
        isOpen={isEditBarOpen}
        onClose={() => setIsEditBarOpen(false)}
        heading="Edit Kanban"
        size="medium"
      >
        <EditRightSideBar />
      </BuilderRightSideBar>
    </div>
  );
};

const EditRightSideBar = () => {
  const { currentBlockConfig, setCurrentBlockConfig } = useAppBlocksContext();
  const { data, table_id } = currentBlockConfig;
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const settingFilters = (type, data) => {
    const newCurrentBlockConfig = { ...currentBlockConfig };
    newCurrentBlockConfig.data[type] = data;
    setCurrentBlockConfig(newCurrentBlockConfig);
  };
  const filterCallback = (data) => {
    const newCurrentBlockConfig = { ...currentBlockConfig };
    newCurrentBlockConfig.data.onscreen_filters.push(data);
    setCurrentBlockConfig(newCurrentBlockConfig);
  };

  const settingFilterArray = (data) => {
    const newObj = { ...currentBlockConfig };
    newObj.data.onscreen_filters = data;
    setCurrentBlockConfig(newObj);
  };

  const tabData = [
    {
      label: "Filters",
      content: (
        <div className="p_3">
          <FilterRenderer
            filters={currentBlockConfig.data.onscreen_filters}
            updateFilters={settingFilterArray}
            tableId={table_id}
          />
        </div>
      )
    },
    {
      label: "Pre-filters",
      content: (
        <PreFilter
          preFilters={data.pre_filters}
          setPreFilters={(data) => settingFilters("pre_filters", data)}
          ownerPreFilters={data.owner_pre_filters}
          setOwnerPreFilters={(data) => settingFilters("owner_pre_filters", data)}
          table_id={table_id}
          prefiltersJoinedBy={data?.prefilters_joined_by || ""}
          setPrefiltersJoinedBy={(data) => settingFilters("prefilters_joined_by", data)}
        />
      )
    },
    {
      label: "General",
      content: <EditGeneralData currentBlockConfig={currentBlockConfig} setCurrentBlockConfig={setCurrentBlockConfig} />
    }
  ];

  return (
    <div>
      <BuilderTabs tabs={tabData} />

      <BuilderModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} modalName={"Add Filter"}>
        <TableTreeModal callbackFunction={filterCallback} tableId={table_id} />
      </BuilderModal>
    </div>
  );
};

const StateTransition = ({ currentBlockConfig, setCurrentBlockConfig, allStates }) => {
  const [fromIdOptions, setFromIdOptions] = useState("");
  const [toIdOptions, setToIdOptions] = useState("");

  const addTransition = () => {
    if (!fromIdOptions || !toIdOptions) {
      toastError("Please select both state");
      return;
    }
    const newConfig = JSON.parse(JSON.stringify(currentBlockConfig));
    const obj = {
      from_id: fromIdOptions,
      to_id: toIdOptions
    };
    newConfig.data.transitions.push(obj);
    setCurrentBlockConfig(newConfig);
    setFromIdOptions("");
    setToIdOptions("");
  };

  const deleteTransition = (index) => {
    const newConfig = JSON.parse(JSON.stringify(currentBlockConfig));
    const newArray = newConfig.data.transitions.filter((_, i) => i !== index);
    newConfig.data.transitions = newArray;
    setCurrentBlockConfig(newConfig);
  };

  return (
    <div>
      <label className="section_main_heading">Make Transitions</label>
      <div className="kanban_transition_selector">
        <SingleSelectBox
          selectedData={fromIdOptions}
          options={currentBlockConfig?.data.states}
          onChange={(obj) => setFromIdOptions(obj.id)}
          placeholder="Select State"
        />
        <div>To</div>
        <SingleSelectBox
          selectedData={toIdOptions}
          options={currentBlockConfig?.data.states}
          onChange={(obj) => setToIdOptions(obj.id)}
          placeholder="Select State"
        />
        <Button onClick={addTransition} variant="secondary">
          + Transitions
        </Button>
      </div>
      <div className="kanban_transition_renderer">
        {currentBlockConfig?.data.transitions.map((transition, index) => (
          <div className="builder_displayBox m_0" style={{ width: "fit-content" }} key={transition.from_id}>
            <div>{allStates[transition.from_id]?.name}</div>
            <span>To</span>
            <div>{allStates[transition.to_id]?.name}</div>
            <ButtonActionIcon type="delete" size="sm" onClick={() => deleteTransition(index)} />
          </div>
        ))}
      </div>
    </div>
  );
};

const EditGeneralData = ({ currentBlockConfig, setCurrentBlockConfig }) => {
  const handleFieldInlineStyle = (data) => {
    const newConfig = JSON.parse(JSON.stringify(currentBlockConfig));
    const newConfigData = newConfig.data || {};

    if (!newConfigData.style) {
      newConfigData.style = {
        className: {},
        inline_style: {}
      };
    }

    newConfigData.style.inline_style = data;

    newConfig.data = newConfigData;
    setCurrentBlockConfig(newConfig);
  };

  return (
    <div className="p_3">
      <InlineStyleSelector
        value={currentBlockConfig.data?.style?.inline_style || {}}
        onChange={handleFieldInlineStyle}
        type="field"
      />
    </div>
  );
};
export default KanbanStatesRenderer;
